import React, { ReactNode } from "react";

import { FiPlus, FiArrowLeft } from "react-icons/fi";

import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

import { Regular, Title } from "@app/components/atoms/Text";

import { useNavigate } from "react-router-dom";
import useStyles from "./styles";
import { FilterAlt } from "@mui/icons-material";

export type StandardHeaderProps = {
  title?: string;
  helperText?: string;
  primaryButton?: boolean;
  secondaryButton?: boolean;
  textPrimaryButton?: string;
  textSecondaryButton?: string;
  primaryIconButton?: ReactNode;
  secondaryIconButton?: ReactNode;
  showBackButton?: boolean;
  onClickPrimaryButton?: () => void;
  onClickSecondaryButton?: () => void;
};

const StandardHeader = ({
  title,
  helperText,
  primaryButton,
  secondaryButton,
  textPrimaryButton,
  textSecondaryButton,
  showBackButton,
  primaryIconButton,
  secondaryIconButton,
  onClickPrimaryButton,
  onClickSecondaryButton,
}: StandardHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const classes = useStyles();

  return (
    <div style={classes.headerCreate}>
      {showBackButton && (
        <Button
          color="primary"
          variant="text"
          size="small"
          onClick={handleBack}
          startIcon={<FiArrowLeft />}
        >
          Voltar
        </Button>
      )}
      <Grid container direction="row" justifyContent="space-between">
        <Grid item xs={6} sm={6}>
          <Title>{title}</Title>
          {helperText && <Regular>{helperText}</Regular>}
        </Grid>
        <Grid
          container
          item
          xs={6}
          sm={6}
          direction="row"
          justifyContent="flex-end"
        >
          {secondaryButton && (
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                onClick={onClickSecondaryButton}
                startIcon={secondaryIconButton}
              >
                {textSecondaryButton}
              </Button>
            </Grid>
          )}
          {primaryButton && (
            <Grid item sx={{ ml: 1 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={onClickPrimaryButton}
                startIcon={primaryIconButton}
              >
                {textPrimaryButton}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

StandardHeader.defaultProps = {
  title: "",
  helperText: "",
  primaryButton: false,
  secondaryButton: false,
  textPrimaryButton: "Novo",
  textSecondaryButton: "Filter",
  onClickPrimaryButton: null,
  primaryIconButton: <FiPlus />,
  secondaryIconButton: <FilterAlt />,
  onClickSecondaryButton: null,
  showBackButton: false,
};

export default StandardHeader;
